import { RAMP_TRANCHES, RAMP_TRANCHE_MS, rampedAmount } from '@views/investor/queries/overhaul-mock.util';

/**
 * TODO: Overhaul — mock-support helper, delete alongside `moves.mock.ts` once the backend reports real
 * cumulative move progress on `MoveDto`. Kept out of `moves.mock.ts` only so the exactness of the ramp can
 * be unit-tested (a `*.mock.spec.ts` file is not picked up by the test runner).
 */

/** The mocked move ramps its "moved to date" in this many equal tranches, one per {@link MOVE_PROGRESS_TRANCHE_MS}. */
export const MOVE_PROGRESS_TRANCHES = RAMP_TRANCHES;
/** Time between mocked move tranches — one tranche (1/5 of the total) is "moved" each minute. */
export const MOVE_PROGRESS_TRANCHE_MS = RAMP_TRANCHE_MS;

/**
 * Cumulative amount "moved to date" for an in-flight move, ramped in equal tranches over time so the
 * account-detail move-underway panel shows partial progress climbing (a thin wrapper over the shared
 * {@link rampedAmount}). 1/{@link MOVE_PROGRESS_TRANCHES} of the total moves each
 * {@link MOVE_PROGRESS_TRANCHE_MS}; the final tranche returns the *exact* total (no rounding residue).
 */
export function moveAmountMovedToDate(
  amount: number | null | undefined,
  createDateNzt: string | null | undefined,
  now: number,
): number {
  return rampedAmount(amount, createDateNzt, now, MOVE_PROGRESS_TRANCHES, MOVE_PROGRESS_TRANCHE_MS);
}
